import { createFileRoute } from '@tanstack/react-router';
import UserLayout from '@components/layout/UserLayout.tsx';
import CustomProductPage from '@features/client/custom-products/CustomProductPage.tsx';

export const Route = createFileRoute('/c/$orgId/$portalId/custom-products')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UserLayout>
      <CustomProductPage />
    </UserLayout>
  );
}
